<div class="change-password-dialog" [formGroup]="changePassword">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <div class="header-icon" aria-hidden="true">
      <mat-icon>lock</mat-icon>
    </div>
    <div class="header-content">
      <h2 class="dialog-title">Change Password</h2>
    </div>
    <button class="close-btn" (click)="onClose()" type="button" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Dialog Content -->
  <div class="dialog-content">
    <div class="form-group">
      <label class="form-label">
        <mat-icon>lock_outline</mat-icon>
        Current Password <span class="required">*</span>
      </label>
      <div class="input-group">
        <input
          matInput
          [type]="currentPassword"
          id="current_password"
          formControlName="current_password"
          class="form-control"
          placeholder="Enter Current Password"
          name="current_password"
          />
        <span matSuffix class="input-actions">
          <img
            (click)="showCurrentPassword('current_password')"
            src="assets/img/auth/eye_icon.png"
            alt="icon"
            class="eye_icon"
            />
        </span>
      </div>
      <app-validation-error
        [formGroup]="changePassword"
        [controlName]="'current_password'"
      ></app-validation-error>
    </div>

    <div class="form-group">
      <label class="form-label">
        <mat-icon>lock_outline</mat-icon>
        New Password <span class="required">*</span>
      </label>
      <div class="input-group">
        <input
          matInput
          [type]="passwordType"
          id="password"
          formControlName="password"
          class="form-control"
          placeholder="Enter New Password"
          name="password"
          />
        <span matSuffix class="input-actions">
          <img
            (click)="showPassword('password')"
            src="assets/img/auth/eye_icon.png"
            alt="icon"
            class="eye_icon"
            />
          <button
            class="btn custom-button"
            (click)="generateAndSetPassword()"
            type="button"
            aria-label="Generate password"
            >
            <mat-icon class="custom-icon">autorenew</mat-icon>
          </button>
        </span>
      </div>
      <app-validation-error
        [formGroup]="changePassword"
        [controlName]="'password'"
      ></app-validation-error>
      @if (changePassword.get('password')?.hasError('minlength')) {
        <mat-error
          class="error-text"
          >Password must be at least 12 characters</mat-error
          >
        }
      </div>

      <div class="form-group">
        <label class="form-label">
          <mat-icon>lock_outline</mat-icon>
          Confirm Password <span class="required">*</span>
        </label>
        <div class="input-group">
          <input
            matInput
            [type]="confirmPasswordType"
            id="password_confirmation"
            formControlName="password_confirmation"
            class="form-control"
            placeholder="Confirm New Password"
            name="password_confirmation"
            />
          <span matSuffix class="input-actions">
            <img
              (click)="showConfirmPassword('password_confirmation')"
              src="assets/img/auth/eye_icon.png"
              alt="icon"
              class="eye_icon"
              />
          </span>
        </div>
        <app-validation-error
          [formGroup]="changePassword"
          [controlName]="'password_confirmation'"
        ></app-validation-error>
      </div>

      @if (
        changePassword.hasError('passwordsMismatch') &&
        changePassword.get('password_confirmation')?.touched &&
        changePassword.get('password')?.touched &&
        changePassword.get('password_confirmation')?.value
        ) {
        <div
          class="error-text"
          >
          New password and confirm password do not match
        </div>
      }
    </div>

    <!-- Dialog Footer -->
    <div class="dialog-footer">
      <button class="btn-cancel" (click)="onClose()">
        <mat-icon>close</mat-icon>
        Cancel
      </button>
      <button class="btn-submit" (click)="saveFormData()">
        <mat-icon>check_circle</mat-icon>
        Confirm
      </button>
    </div>
  </div>
